import { useQuery } from '@tanstack/react-query';
import { MsApiEndPoints } from '@wolfejs/ms-api-js/src';
import type { PGCandidateOrderEntity } from '@wolfejs/ms-api-js/src/types/orders';
import type { ReactQueryOptions } from '@wolfejs/ms-api-react/src/types';
import Cookies from 'js-cookie';
import { useMsClient } from '../../..';
import { getCandidateOrder } from './api';

/**
 * A candidate order in PG corp IS the cart. A new candidate order is created every time a user edits items in their "cart".
 * This hook is used to get an individual candidate order
 */
export function usePGCorpCandidateOrder(options?: ReactQueryOptions<PGCandidateOrderEntity>) {
  const { client } = useMsClient();
  const candidateOrderId = Cookies.get('_pgcorp_cart_uuid') || '';

  const key = MsApiEndPoints.pgcorp.getCandidateOrder(candidateOrderId);

  return useQuery({
    ...options,
    queryKey: [key],
    queryFn: () => getCandidateOrder(client, candidateOrderId),
    enabled: Boolean(candidateOrderId),
  });
}
